'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constant = require('../constant');

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (win, doc) {
  if (typeof win[_constant2.default.ANDROID_BRIDGE_NAME] !== 'undefined') {
    return win[_constant2.default.ANDROID_BRIDGE_NAME];
  }

  var util = function () {
    var getNonceStr = function getNonceStr() {
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var maxLen = chars.length;
      var ret = '';
      for (var i = 0; i < maxLen; i++) {
        ret += chars.charAt(Math.floor(Math.random() * maxLen));
      }
      return ret;
    };
    var generateKey = function generateKey() {
      return +new Date() + '' + getNonceStr();
    };
    var once = function once(func) {
      var ran = false,
          memo = void 0;
      return function () {
        if (ran) return memo;
        ran = true;
        memo = func.apply(this, arguments);
        func = null;
        return memo;
      };
    };
    return {
      getNonceStr: getNonceStr,
      generateKey: generateKey,
      once: once
    };
  }();
  var AndroidBridge = function () {
    var out = {};
    var _handlers = {};
    var _invoker = function _invoker() {};
    var _context = win;
    var nop = function nop() {};
    var _invoke = function _invoke(arg) {
      _context[_invoker].apply(_context, arg);
    };
    var setInvoker = function setInvoker(context, invoker) {
      _context = context;
      _invoker = invoker;
    };
    var setInvokerOnce = util.once(setInvoker);
    var releaseInvoker = function releaseInvoker() {
      _context = win;
      _invoker = function _invoker() {};
    };
    var setHandler = function setHandler(handler) {
      var key = util.generateKey();
      _handlers[key] = handler;
      return key;
    };
    var callHandler = function callHandler() {
      for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
      }

      var handler = _handlers[data[0]] || nop;
      handler.apply(win, data.slice(1));
    };
    var registerHandler = function registerHandler(name, cb) {
      _handlers[name || _constant2.default.DEFAULT_CALLHANDLER_NAME] = cb;
    };
    var invoke = function invoke() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var cb = args[args.length - 1];
      var key = setHandler(cb);
      _invoke(args.slice(0, -1).concat(key));
    };
    return {
      setInvoker: setInvoker,
      setInvokerOnce: setInvokerOnce,
      releaseInvoker: releaseInvoker,
      callHandler: callHandler,
      invoke: invoke,
      registerHandler: registerHandler
    };
  }();
  var initEvent = function initEvent() {
    var e = doc.createEvent('Events');
    e.initEvent(_constant2.default.ANDROID_BRIDGE_READY_EVENT, false, false);
    e.bridge = AndroidBridge;
    doc.dispatchEvent(e);
  };

  win[_constant2.default.ANDROID_BRIDGE_NAME] = AndroidBridge;
  initEvent();

  return AndroidBridge;
}(window, document);